import React, { useMemo, useState } from "react";
import SEOHead from "@/components/SEOHead";
import VitrineHero from "@/components/vitrine/VitrineHero";
import VitrineFilters from "@/components/vitrine/VitrineFilters";
import VitrineCard from "@/components/vitrine/VitrineCard";
import VitrineDemoModal from "@/components/vitrine/VitrineDemoModal";
import VitrineCTASection from "@/components/vitrine/VitrineCTASection";
import {
  vitrineItems,
  type VitrineCategory,
  type VitrineItem,
} from "@/components/vitrine/data/vitrineItems";

const VitrinePage = () => {
  const [active, setActive] = useState<VitrineCategory | "all">("all");
  const [selected, setSelected] = useState<VitrineItem | null>(null);
  const [open, setOpen] = useState(false);

  const filtered = useMemo(
    () => (active === "all" ? vitrineItems : vitrineItems.filter((i) => i.category === active)),
    [active]
  );

  const counts = useMemo(() => {
    const map: Record<string, number> = { all: vitrineItems.length };
    for (const item of vitrineItems) {
      map[item.category] = (map[item.category] || 0) + 1;
    }
    return map;
  }, []);

  const handleOpen = (item: VitrineItem) => {
    setSelected(item);
    setOpen(true);
  };

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "ItemList",
    name: "Vitrine de Ferramentas — IA Palpite Guru",
    itemListElement: vitrineItems.map((i, idx) => ({
      "@type": "ListItem",
      position: idx + 1,
      name: i.title,
      description: i.tagline,
      url: `https://aipalpiteguru.mentepoderosa2030.com${i.route}`,
    })),
  };

  return (
    <>
      <SEOHead
        title="Vitrine — Todas as ferramentas do IA Palpite Guru"
        description="Conheça todos os métodos, IA, estatísticas, resultados ao vivo, loja e ferramentas do IA Palpite Guru. Descubra tudo que pode turbinar seus jogos."
        keywords="vitrine, métodos jogo do bicho, ia palpite guru, ferramentas apostas, estatísticas bicho, gerador de palpites"
        canonical="/vitrine"
        jsonLd={jsonLd}
      />
      <div className="container mx-auto px-4 py-8 space-y-8">
        <VitrineHero />

        <div className="space-y-4">
          <VitrineFilters active={active} onChange={setActive} counts={counts} />
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
            {filtered.map((item) => (
              <VitrineCard key={item.id} item={item} onClick={() => handleOpen(item)} />
            ))}
          </div>
        </div>

        <VitrineCTASection />
      </div>

      <VitrineDemoModal item={selected} open={open} onOpenChange={setOpen} />
    </>
  );
};

export default VitrinePage;
